/* tslint:disable */
/* eslint-disable */
/**
 * Ordering Api
 * Its4 Plan Ordering Api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProjectWithAmount } from './ProjectWithAmount';
import {
    ProjectWithAmountFromJSON,
    ProjectWithAmountFromJSONTyped,
    ProjectWithAmountToJSON,
    ProjectWithAmountToJSONTyped,
} from './ProjectWithAmount';

/**
 * 
 * @export
 * @interface SendAdditionalDoneProjectsRequest
 */
export interface SendAdditionalDoneProjectsRequest {
    /**
     * 
     * @type {Date}
     * @memberof SendAdditionalDoneProjectsRequest
     */
    doneDate: Date;
    /**
     * 
     * @type {Array<ProjectWithAmount>}
     * @memberof SendAdditionalDoneProjectsRequest
     */
    projectsWithAmounts: Array<ProjectWithAmount>;
}

/**
 * Check if a given object implements the SendAdditionalDoneProjectsRequest interface.
 */
export function instanceOfSendAdditionalDoneProjectsRequest(value: object): value is SendAdditionalDoneProjectsRequest {
    if (!('doneDate' in value) || value['doneDate'] === undefined) return false;
    if (!('projectsWithAmounts' in value) || value['projectsWithAmounts'] === undefined) return false;
    return true;
}

export function SendAdditionalDoneProjectsRequestFromJSON(json: any): SendAdditionalDoneProjectsRequest {
    return SendAdditionalDoneProjectsRequestFromJSONTyped(json, false);
}

export function SendAdditionalDoneProjectsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendAdditionalDoneProjectsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'doneDate': (new Date(json['doneDate'])),
        'projectsWithAmounts': ((json['projectsWithAmounts'] as Array<any>).map(ProjectWithAmountFromJSON)),
    };
}

  export function SendAdditionalDoneProjectsRequestToJSON(json: any): SendAdditionalDoneProjectsRequest {
      return SendAdditionalDoneProjectsRequestToJSONTyped(json, false);
  }

  export function SendAdditionalDoneProjectsRequestToJSONTyped(value?: SendAdditionalDoneProjectsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'doneDate': ((value['doneDate']).toISOString().substring(0,10)),
        'projectsWithAmounts': ((value['projectsWithAmounts'] as Array<any>).map(ProjectWithAmountToJSON)),
    };
}

